var cov_ve31ilof6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Popover/Content.tsx",
      hash = "f56c007e576b59f4e12b657ded17083eef41b795",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Popover/Content.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 42
        }
      }
    },
    fnMap: {
      "0": {
        name: "Content",
        decl: {
          start: {
            line: 5,
            column: 9
          },
          end: {
            line: 5,
            column: 16
          }
        },
        loc: {
          start: {
            line: 5,
            column: 45
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Popover/Content.tsx";
import React from 'react';
import Panel from './Panel';

function Content(props) {
  cov_ve31ilof6.f[0]++;
  cov_ve31ilof6.s[0]++;
  return (
    /*#__PURE__*/
    React.createElement(Panel, Object.assign({}, props, {
      useTextStyle: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 6,
        columnNumber: 10
      }
    }))
  );
}

export default Content;